<section id="Sejam" style="background-image: url('assets/images/fingerprint.svg');">
    <div class="row">
        <div class="title-section">
            <h1>افتتاح حساب در کارگزاری آبان</h1>
        </div>
        <div class="body-section">
            <p><strong>اینجا ثبت نام کن، هم احراز هویت سجام و کارگزاری رو انجام میدی، هم کد بورسی می‌گیری و هم حساب کارگزاری برات فعال میشه!</strong></p>
            <a target="_blank" href="https://ehraz.aban.net" class="button">ثبت نام</a>
        </div>
    </div>
</section>